var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-card-title',[_c('span',{staticClass:"f-default",domProps:{"innerHTML":_vm._s(_vm.data.title)}})]),_c('b-card-text',[_c('h4',[_c('span',{staticClass:"f-default",domProps:{"innerHTML":_vm._s(_vm.data.content)}})]),_vm._t("other_value"),_vm._t("other_value_2")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }